module.exports = __webpack_public_path__ + "house-blueprint-chocolate-ice-cream.fe32320460eac3eff50e.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/house-blueprint-chocolate-ice-cream.svg
// module id = ../../../../../src/assets/img/house-blueprint-chocolate-ice-cream.svg
// module chunks = main